<template>
  <div class="outline">
    <div class="leftRow">
      <div class="body">
        <img src="@/assets/image/logo.png" class="middleImg" />
        <div style="margin:4.444vh 0px 0px 3.0208vw;height:9.259vh">
          <div style="float:left">
            <div class="english">FOOD</div>
          </div>
          <div class="chinese">美食</div>
        </div>
        <div class="footerMenu" style="margin-left:1.71875vw">
          <div
            :class="classNameB"
            @mouseover="classNameB = 'colAHover'"
            @mouseout="classNameB = 'colA'"
            @click="openTypeLise(2)"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">特</div>
            <div class="chaFont">色</div>
            <div class="chaFont">餐</div>
            <div class="chaFont">饮</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
          <div
            :class="classNameD"
            @mouseover="classNameD = 'colAHover'"
            @mouseout="classNameD = 'colA'"
            @click="openTypeLise(1)"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">美</div>
            <div class="chaFont">食</div>
            <div class="chaFont">推</div>
            <div class="chaFont">荐</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../../components/common/banner";
import  "@/css/switch.css"
export default {
  name: "OutLine",
  components: { Banner },
  data() {
    return {
      classNameA: "colA",
      classNameB: "colA",
      classNameC: "colA",
      classNameD: "colA"
    };
  },
  methods: {
    openTypeLise(type) {
      this.$store.commit("setChildMenu",6);
      this.$store.commit("setTabPage", type);
      let name = "TabFood";
      this.$store.commit("setShowSwitchMenu", false);
      this.$emit("specialtyListFunction", name);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/food/foodSwitch.vue